import { Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';

import { EventDetailCard } from '../event-detail-card';
import { useEventPopover } from './useEventPopover';

import type { ReactElement } from 'react';
import type { IEvent } from '../../../lib';

export interface IEventCardHandlers {
	onClick: () => void;
	onMouseEnter: () => void;
	onMouseLeave: () => void;
}

interface IEventPopoverProps {
	event: IEvent;
	isSameDayEvent: boolean;
	showTooltip: boolean;
	onOpenModal: () => void;
	children: (handlers: IEventCardHandlers) => ReactElement;
}

export const EventPopover = ({ event, isSameDayEvent, showTooltip, onOpenModal, children }: IEventPopoverProps) => {
	const {
		isPopoverOpen,
		handleContentClick,
		handleEventMouseEnter,
		handleEventMouseLeave,
		handlePopoverClose,
		handlePopoverMouseEnter,
		handlePopoverMouseLeave,
	} = useEventPopover(showTooltip, onOpenModal);

	const content = children({
		onClick: handleContentClick,
		onMouseEnter: handleEventMouseEnter,
		onMouseLeave: handleEventMouseLeave,
	});

	if (!showTooltip) {
		return content;
	}

	return (
		<Popover placement='top-start' isLazy isOpen={isPopoverOpen} onClose={handlePopoverClose}>
			<PopoverTrigger>{content}</PopoverTrigger>
			<Portal>
				<PopoverContent
					w='350px'
					bg='none'
					boxShadow='none'
					onMouseEnter={handlePopoverMouseEnter}
					onMouseLeave={handlePopoverMouseLeave}
					className='cp-popover-content'
				>
					<PopoverBody p={0} bg='none' w='full'>
						<EventDetailCard event={event} isSameDayEvent={isSameDayEvent} />
					</PopoverBody>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};
